/**
 * The draw tile's state. An offer I must ANSWER is answered on its dock card,
 * not here, so an incoming offer only disables this tile.
 *
 * `showAbort` HIDES the tile rather than disabling it (P1-2), which is what the
 * old screen does (`BottomControlsComponent` L129: `!showDrawRequest &&
 * !drawRequestSent && !showAbort && playing`) and what the app lane does
 * (`BottomControls/View.tsx` L249-257). There is nothing to offer a draw about
 * before the first move, and the live tile sat next to Abort.
 */
import {useLiveGame} from '@/Store/liveGameStore';
import {
  selectDrawState,
  selectGameOver,
  selectShowAbort,
} from '@/Store/liveGame/selectors';
import {useShallow} from 'zustand/react/shallow';

export type DrawTileModel = {
  /** my offer is out and unanswered ("Offered · waiting") */
  drawSent: boolean;
  /** the pre-first-move window is open -> the tile is not mounted at all */
  showAbort: boolean;
  disabled: boolean;
  onPress: () => void;
};

export function useDrawTileModel(): DrawTileModel {
  const {drawOffered, drawSent} = useLiveGame(useShallow(selectDrawState));
  const gameOver = useLiveGame(selectGameOver);
  const showAbort = useLiveGame(selectShowAbort);
  const offerDraw = useLiveGame(s => s.actions.offerDraw);

  return {
    drawSent,
    showAbort,
    disabled: gameOver || drawSent || drawOffered,
    onPress: offerDraw,
  };
}
